export const IGNORED_ERRORS = ['GraphQL error: 401 Unauthorized'];
